<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des chargements des fichiers de rentes Inval (auto/manuelles)</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-row>
                <b-col md="3" class="mt-2">
                  <label for="fichier"><strong>Fichier : </strong></label>
                </b-col>
                <b-col md="7">
                  <b-form-group label-for='nom_fichier'>
                    <b-form-file placeholder="Joindre un fichier"
                                 id="fichier"
                                 class="file-input"
                                 drop-placeholder="Déposer le fichier ici..."
                                 browse-text="Parcourir"
                                 :state="errors.attachment !== '' ? false : null"
                                 @change="addFile($event)">
                    </b-form-file>
                    <span class="field-error">{{ errors.attachment }}</span>
                    <b-form-text id="file-help">Fichier CSV contenant une colonne avec les id des dossiers</b-form-text>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button type="enter" @click.prevent="importFile" size="md" variant="primary">
                    <i class="fa fa-upload"></i> Importer
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <v-client-table v-if="dataIsReady" class="mt-4" :columns="columns" :data="items" :options="options">
            <div v-if="props.row.date_traitement" slot="date_traitement" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.date_traitement) }}</span>
            </div>
            <div v-if="props.row.nom_gestionnaire" slot="nom_gestionnaire" slot-scope="props">
              {{ props.row.nom_gestionnaire }} {{ props.row.prenom_gestionnaire }}
            </div>
            <div v-if="props.row.status" slot="status" slot-scope="props">
              {{ props.row.status.libelle_bo }}
            </div>
            <div v-if="props.row.commentaire" slot="commentaire" slot-scope="props">
              {{ props.row.commentaire }}
            </div>
            <div slot="nom_fichier" slot-scope="props" class="slot-date">
              <span class="clickable" @click="download(props.row)">{{ props.row.nom_fichier }} <i class="fa fa-download"></i></span>
            </div>
            <div slot="nb_lignes_ok" slot-scope="props">
              <span class="badge badge-success p-2 mr-2" v-if="props.row.nb_lignes_ok !== 0"> {{ props.row.nb_lignes_ok }} OK </span>
              <span class="badge badge-warning p-2" v-if="props.row.nb_lignes_ok !== 0 && props.row.nb_lignes_ok < props.row.nb_lignes_total"> {{ (props.row.nb_lignes_total * 1) - (props.row.nb_lignes_ok * 1)  }} KO</span>
              <span class="badge badge-danger p-2" v-if="props.row.nb_lignes_ok === 0">{{ props.row.nb_lignes_total }} KO</span>
            </div>
            <div slot="action" slot-scope="props">
              <b-button v-if="Object.keys(props.row.rapport).length > 0" type="button"
                        @click.prevent="seeErrors(props.row)" class="badge badge-info mr-3 p-2">
                <i class="fa fa-eye"></i> Voir
              </b-button>
            </div>
          </v-client-table>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-modal size="xl" centered scrollable id="modal-rapport" ref="modal-rapport" title="Rapport du traitement du fichier">
      <h5>Nombre de dossier total : <b>{{ nbLigneTotal }}</b></h5>
      <h5>Nombre de dossier traités : <b>{{ nbLigneOk }}</b></h5>
      <ul class="mt-3">
        <li v-for="(error, key) in rapportErrors" :key="key" v-html="error"></li>
      </ul>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="$bvModal.hide('modal-rapport')">Fermer</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {hasRule, espaceGestionRules} from "@/utils/rulesHelper";
  import {downloadFile, isEmpty} from "@/utils/fileHelper";
  import {formatDate} from "@/utils/communHelper";

  export default {
    name: "histo_chargement_rentes_inval",
    data() {
      return {
        formatDate,
        isEmpty,
        rules: espaceGestionRules,
        dataIsReady: false,
        attachment: null,
        statusId: '',
        commentaire: '',
        allStatus: [],
        statusOptions: [],
        allTraitements: [],
        traitementOptions: [],
        selectedTraitement: '',
        nbLigneTotal: null,
        nbLigneOk: '0',
        rapportErrors: [],
        errors: {
          attachment: '',
          statusId: '',
          commentaire: '',
          traitement: '',
        },
        columns: ['date_traitement', 'nom_gestionnaire', 'profil_gestionnaire', 'status', 'commentaire', 'nom_fichier', 'nb_lignes_ok', 'action'],
        items: [],
        options: {
          headings: {
            date_import: 'Date traitement',
            nom_gestionnaire: 'Nom Prénom',
            profil_gestionnaire: 'Profil utilisateur',
            status: 'Statut sélectionné',
            commentaire: 'Commentaire',
            nom_fichier: 'Nom Fichier',
            action: 'Rapport',
          },
          perPage: 10,
          filterable: false,
          sortable: ['date_traitement', 'nom_gestionnaire', 'profil_gestionnaire', 'nom_fichier'],
          perPageValues: [10, 25, 50],
        },
      }
    },
    watch: {
    },
    created() {
      this.getAllStatus();
      this.getAllTraitements();
      this.all();
    },
    methods: {
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      importFile() {
        if (this.validateData()) {
          let self = this;
          this.$store.commit("IS_LOADING", true);
          let formData = new FormData();
          formData.append('file', this.attachment);
          formData.append('status_id', this.statusId);
          formData.append('commentaire', this.commentaire);
          formData.append('traitementId', this.selectedTraitement);
          this.$axios
            .post(`/espaceGestion/ocp/chargement`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((response) => {
              this.all();
              this.clearForm();
              this.showRapport(response.data);
              this.$store.commit("IS_LOADING", false);
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.handleErrors(error);
            });
        }
      },
      showRapport(resultat) {
        this.nbLigneOk = resultat.nbLigneDone;
        this.nbLigneTotal = resultat.nbLigneTotal;
        this.rapportErrors = resultat.rapport;
        this.$refs['modal-rapport'].show();
      },
      getAllStatus() {
        return new Promise((resolve, reject) => {

          let self = this;
          let data = {
            libelle_categorie: 'status_dossier'
          }
          this.$axios
            .post("/administration/status/allStatutsByType", data)
            .then(response => {
              this.allStatus = response.data.allStatus;
              for (let status of response.data.statusTraite.sous_statuts) {
                this.statusOptions.push({value: status.id, text: status.libelle_bo});
              }
              this.statusOptions.push({value: response.data.statusNeutralise.id, text: response.data.statusNeutralise.libelle_bo});
              resolve();
            })
            .catch((error) => {
              self.handleErrors(error);
              resolve();
            });
        })
      },
      getAllTraitements() {
        return new Promise((resolve, reject) => {
          let self = this;

          this.$axios
            .get("/administration/traitements")
            .then(response => {
              this.allTraitements = response.data.traitements;
              for (let traitement of response.data.traitements) {
                if (traitement.categorie === 'Production' && traitement.type === 'Principal' && traitement.libelle_technique !== 'qualification_courrier' && traitement.libelle_technique !== 'gestion_dbco') {
                  this.traitementOptions.push({value: traitement.id, text: traitement.libelle});
                }
              }
              resolve();
            })
            .catch((error) => {
              self.handleErrors(error);
              resolve();
            });
        })
      },
      all() {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/ocp/get-all-historique")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch((error) => {
            self.$store.commit("IS_LOADING", false);
            self.handleErrors(error);
          });
      },
      validateData() {
        this.clearErrors();
        let valid = true;

        if (isEmpty(this.attachment)) {
          this.errors.attachment = "Veuillez choisir un fichier";
          valid = false;
        }
        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = "Veuillez saisir un commentaire à mettre dans le post-it";
          valid = false;
        }
        if (isEmpty(this.statusId)) {
          this.errors.statusId = "Veuillez sélectionner le statut à mettre aux dossiers";
          valid = false;
        }
        if (isEmpty(this.selectedTraitement)) {
          this.errors.traitement = "Veuillez sélectionner un traitement";
          valid = false;
        }
        return valid;
      },
      clearForm() {
        this.attachment = '';
        this.statusId = '';
        this.commentaire = '';
        this.selectedTraitement = '';
      },
      clearErrors() {
        this.errors.attachment = "";
        this.errors.commentaire = "";
        this.errors.statusId = "";
        this.errors.traitement = "";
      },
      seeErrors(script) {
        let resultat = {
          rapport: script.rapport,
          nbLigneDone: script.nb_lignes_ok,
          nbLigneTotal: script.nb_lignes_total,
        }
        this.showRapport(resultat);
      },
      download(script) {
        let self = this;
        let fileNameArr = script.nom_fichier.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');

        this.$axios
          .get("/espaceGestion/opc/download-opc-file/"+script.id, {responseType: 'blob'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch((error) => {
            self.handleErrors(error);
          })
      },
      handleErrors(error) {
        console.log(error)
        let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
        if (!isEmpty(error) && error.response && error.response.status !== 500) {
          // console.log(error.response)
          errorText = error.response.data.message;
        }
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: errorText,
          showConfirmButton: false,
          timer: 4000,
        });
      },
      canExecute(rule) {
        return hasRule(rule);
      },
      displayPopup(type, title, text) {
        this.$swal({
          position: 'top',
          type: type,
          title: title,
          text: text,
          showConfirmButton: false,
          timer: 3000
        });
      },
    }
  }
</script>
